export const NOTIFICATION_THEME_GENERIC = 'generic';
export const NOTIFICATION_THEME_PURPLE = 'purple';
export const NOTIFICATION_THEME_SUCCESS = 'success';
export const NOTIFICATION_THEME_GOLD = 'gold';
export const NOTIFICATION_THEME_ERROR = 'error';
export const NOTIFICATION_THEME_DARK = 'dark';
export const NOTIFICATION_THEME_BLUE = 'blue';
export const NOTIFICATION_THEME_PLATINUM = 'platinum';

export type NotificationTheme =
  | typeof NOTIFICATION_THEME_GENERIC
  | typeof NOTIFICATION_THEME_PURPLE
  | typeof NOTIFICATION_THEME_SUCCESS
  | typeof NOTIFICATION_THEME_GOLD
  | typeof NOTIFICATION_THEME_ERROR
  | typeof NOTIFICATION_THEME_DARK
  | typeof NOTIFICATION_THEME_BLUE
  | typeof NOTIFICATION_THEME_PLATINUM;
